import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import './Casestudydetails.css';

const Casestudydetails = () => {
    const { id } = useParams();
    const [caseStudy, setCaseStudy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchCaseStudy = async () => {
            try {
                const response = await fetch(`https://api.ndtechland.com/api/HomeApi/GetCaseStudyById?Id=${id}`);
                const data = await response.json();

                if (data.status === 200) {
                    setCaseStudy(data.data);
                } else {
                    throw new Error(data.message);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCaseStudy();
    }, [id]);

    if (loading) {
        return (
            <>
                <Header />
                <div className="casestudy-loading-state">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    if (error || !caseStudy) {
        return (
            <>
                <Header />
                <div className="casestudy-error-state">
                    <p className="text-danger">{error || 'No case study found.'}</p>
                    <Link to="/casestudy" className="btn btn-primary mt-3">Back to Case Studies</Link>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header />
            <section className="casestudy-detail-section">
                <div className="container">
                    <div className="mb-4">
                        <Link to="/casestudy" className="casestudy-back-link">
                            <FaArrowLeft />
                            <span>Back to Case Studies</span>
                        </Link>
                    </div>

                    <div className="case-study-detail-wrapper">
                        <div className="case-study-header-area">
                            <span className="case-study-badge-tag">Case Study</span>
                            <h1 className="case-study-main-title">{caseStudy.title}</h1>
                        </div>

                        <div className="case-study-detail-body">
                            <div className="case-study-image-container">
                                <img 
                                    src={`https://api.ndtechland.com/image/${caseStudy.image}`} 
                                    alt={caseStudy.title} 
                                    className="case-study-detail-img" 
                                />
                            </div>
                            <div 
                                className="case-study-rich-content" 
                                dangerouslySetInnerHTML={{ __html: caseStudy.description }} 
                            />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Casestudydetails;
